module.exports = {
	timeBetween: 60,
	strategy: 'load',
	hiddenType: 'focus',
	reloadTimes: 2,
	minVisibility: 70,
	maxEmptyReturnRetries: 1,
	timeBetweenEmptyRetry: 10,
	noSpaceTime: 1,
	fType: 'incl',
};
